import SandBoxDataTable from './sandBoxDataTable'
export default SandBoxDataTable
